import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './Button';

export interface BreadcrumbItem {
  label: ReactNode;
  path?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onBack?: () => void;
}
export const Breadcrumb = ({ items, onBack }: BreadcrumbProps) => {
  if (items.length === 0) return null;

  return (
    <div className="flex items-center gap-3">
      {onBack && (
        <Button
          variant="primary"
          onClick={onBack}
          className="w-6 h-6 !p-0 shrink-0"
          aria-label="Back"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
        </Button>
      )}
      <nav className="flex items-center gap-1.5 text-[14px]">
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <Fragment key={idx}>
              {isLast ? (
                <span className="text-[#242933] font-semibold">{item.label}</span>
              ) : (
                <Link to={item.path || '#'} className="text-gray-400 font-normal hover:text-gray-600">
                  {item.label}
                </Link>
              )}
              {!isLast && <span className="text-gray-300">›</span>}
            </Fragment>
          );
        })}
      </nav>
    </div>
  );
};
